import { Center, Loader } from "@mantine/core";

export const CenteredLoader = () => {
  return (
    <Center mt="xl">
      <Loader />
    </Center>
  );
};
